<template>
<div class="action-flow-node action-flow-node-danger" style="height: 200px;">
	<div class="action-flow-title">Clone Mote</div>
	<div class="action-flow-hint">Clone a single mote of data, creating a new identical mote.</div>
	
	<ActionParamHint label="Mote" hint="Source mote to clone." param-class="param-tgt" />
	<ActionParamHint label="Original" hint="The original mote before cloning." param-class="param-src" />
	<ActionParamHint label="Copy" hint="The cloned mote after cloning." param-class="param-src" />
	
	<Handle type="target" id="tgt-mote" :position="Position.Left" style="top: 95px;" />
	<Handle type="source" id="src-original" :position="Position.Right" style="top: 135px;" />
	<Handle type="source" id="src-copy" :position="Position.Right" style="top: 175px;" />
</div>
</template>

<script setup>
/* eslint-disable */
import { ref } from 'vue'
import { Handle, Position, useNodesData, useVueFlow } from '@vue-flow/core'
import ActionParamHint from './action-param-hint.vue'

const props = defineProps({
	id: String,
});

// Access the current node's data
const nodeData = useNodesData(() => props.id);
const { updateNode } = useVueFlow()

// Store parameter values
const parameters = ref({
});

// Handle parameter changes from ActionParamHint components
const handleParamChange = (paramData) => {
	// Store the parameter value based on the label
	let key = paramData.label.toLowerCase();
	if (!(key in parameters.value)) {
		console.error(`Unknown parameter label: ${paramData.label}`);
		return;
	}
	parameters.value[key] = paramData.value;
	
	// Update the node data in Vue Flow.
	updateNode(props.id, (node) => ({
		data: {
			...node.data,
			...parameters.value
		}
	}));
}

</script>

